import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import ButtonContained from "../components/ButtonPrimaryContained";
import ButtonOutlined from "../components/ButtonPrimaryOutlined";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { useDispatch } from "react-redux";
import Badge from "@mui/material/Badge";
import Avatar from "@mui/material/Avatar";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import TextField from "@mui/material/TextField";
import { Input, InputLabel } from "@mui/material";

export default function CreateServiceForm({
  onClose,
  showCreateModal,
  table,
  action,
  username,
  type,
}) {
  const dispatch = useDispatch();
  const [titleImage, setTitleImage] = useState("");
  const [titleImagePreview, setTitleImagePreview] = useState("");
  const [featuresImage, setFeaturesImage] = useState("");
  const [featuresImagePreview, setFeaturesImagePreview] = useState("");
  const [titleEn, setTitleEn] = useState("");
  const [titleAr, setTitleAr] = useState("");
  const [descriptionEn, setDescriptionEn] = useState("");
  const [descriptionAr, setDescriptionAr] = useState("");
  const [featuresTitleEn, setFeaturesTitleEn] = useState("");
  const [featuresTitleAr, setFeaturesTitleAr] = useState("");

  useEffect(() => {
    if (titleImage) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setTitleImagePreview(reader.result);
      };
      reader.readAsDataURL(titleImage);
    }
  }, [titleImage]);

  useEffect(() => {
    if (featuresImage) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFeaturesImagePreview(reader.result);
      };
      reader.readAsDataURL(featuresImage);
    }
  }, [featuresImage]);

  const handleTitleImageSelect = (event) => {
    const file = event.target.files[0];
    if (file) {
      setTitleImage(file);
    }
  };

  const handleFeaturesImageSelect = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFeaturesImage(file);
    }
  };

  const handleClose = () => {
    setTitleImage("");
    setTitleImagePreview("");
    setFeaturesImage("");
    setFeaturesImagePreview("");
    onClose();
  };

  const handleSubmit = () => {
    const formData = new FormData();
    formData.append("title", JSON.stringify({ en: titleEn, ar: titleAr }));
    formData.append(
      "description",
      JSON.stringify({ en: descriptionEn, ar: descriptionAr })
    );

    if (titleImage) {
      formData.append("image", titleImage);
    }

    if (featuresImage) {
      formData.append("featureImage", featuresImage);
    }

    formData.append(
      "featureTitle",
      JSON.stringify({ en: featuresTitleEn, ar: featuresTitleAr })
    );
    formData.append("table", table);
    formData.append("username", username);

    dispatch(action(formData));

    setTitleImage("");
    setFeaturesImage("");
    setTitleImagePreview("");
    setFeaturesImagePreview("");
    onClose();
  };

  return (
    <Modal
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      open={showCreateModal}
      onClose={handleClose}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          border: "2px solid #000",
          boxShadow: 24,
          p: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "2em",
          maxHeight: "100%",
          overflowY: "auto",
        }}
      >
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Create new row in {table}
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "1em",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "1em",
            }}
          >
            <InputLabel>Title Image</InputLabel>
            <Badge
              overlap="circular"
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              badgeContent={
                <InputLabel
                  htmlFor="title-image-upload"
                  style={{ cursor: "pointer" }}
                >
                  <CloudUploadIcon color="primary" />
                  <Input
                    id="title-image-upload"
                    type="file"
                    style={{ display: "none" }}
                    onChange={handleTitleImageSelect}
                  />
                </InputLabel>
              }
            >
              <Avatar
                alt=""
                src={titleImagePreview}
                sx={{ width: "100px", height: "100px" }}
              />
            </Badge>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "1em",
            }}
          >
            <InputLabel>Features Image</InputLabel>
            <Badge
              overlap="circular"
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              badgeContent={
                <InputLabel
                  htmlFor="features-image-upload"
                  style={{ cursor: "pointer" }}
                >
                  <CloudUploadIcon color="primary" />
                  <Input
                    id="features-image-upload"
                    type="file"
                    style={{ display: "none" }}
                    onChange={handleFeaturesImageSelect}
                  />
                </InputLabel>
              }
            >
              <Avatar
                alt=""
                src={featuresImagePreview}
                sx={{ width: "100px", height: "100px" }}
              />
            </Badge>
          </Box>
        </Box>
        <TextField
          required
          id="title-en"
          label="Title (English)"
          onChange={(event) => setTitleEn(event.target.value)}
        />
        <TextField
          required
          id="title-ar"
          label="Title (Arabic)"
          onChange={(event) => setTitleAr(event.target.value)}
        />
        <TextField
          required
          id="description-en"
          label="Description (English)"
          multiline
          rows={4}
          onChange={(event) => setDescriptionEn(event.target.value)}
        />
        <TextField
          required
          id="description-ar"
          label="Description (Arabic)"
          multiline
          rows={4}
          onChange={(event) => setDescriptionAr(event.target.value)}
        />
        <TextField
          required
          id="features-title-en"
          label="Features Title (English)"
          onChange={(event) => setFeaturesTitleEn(event.target.value)}
        />
        <TextField
          required
          id="features-title-ar"
          label="Features Title (Arabic)"
          onChange={(event) => setFeaturesTitleAr(event.target.value)}
        />
        <Box style={{ display: "flex", gap: "1em" }}>
          <ButtonContained onClick={handleSubmit} label="Submit" />
          <ButtonOutlined onClick={handleClose} label="Close" />
        </Box>
      </Box>
    </Modal>
  );
}
